'use strict';

module.exports = /* @ngInject */ ["$q", "authApiFactory", "authTokenProvider", "impersonationService", "winINetCookieRepository", "rediVersionCheck", "EIKON_SESSION_COOKIE_NAME", "openFinApi", "eikonHeartbeatRepository", "$log", function ($q,
                                           authApiFactory,
                                           authTokenProvider,
                                           impersonationService,
                                           winINetCookieRepository,
                                           rediVersionCheck,
                                           EIKON_SESSION_COOKIE_NAME,
                                           openFinApi,
                                           eikonHeartbeatRepository,
                                           $log) {
  var that = this;
  var ssoCookiePromise;

  that.getEikonSsoCookie = function () {
    if (!ssoCookiePromise) {
      ssoCookiePromise = rejectOrGetEikonSsoCookies()
          .then(function(cookies){
            publishRegisterWithEikon();
            return cookies;
          });
    }
    return ssoCookiePromise;
  };

  function rejectOrGetEikonSsoCookies() {
    return rejectIfImpersonating()
      .then(rejectIfRediVersionDoesNotSupportEikon)
      .then(function(){
        return getCookies();
      })
  }

  that.endEikonSession = function () {
    $log.info('Ending eikon session');
    return that.getEikonSsoCookie().then(function (cookies) {
      var eikonSessionCookieValue = that.extractEikonToken(cookies);
      return logoutFromServer(eikonSessionCookieValue)
          .finally(function () {
              ssoCookiePromise = undefined;
              return winINetCookieRepository.deleteEikonSsoCookies();
          });
    });
  };

  that.extractEikonToken = function(cookies) {
    return _(cookies)
        .map(getEikonTokenFromSingleCookie)
        .compact()
        .head();
  };

  that.getEikonToken = function(){
    return that.getEikonSsoCookie().then(
        function (cookies) {
          var token = that.extractEikonToken(cookies);
          if (token) {
            return token;
          }
          return $q.reject();
        });
  };

  that.handleEikonSessionIsInvalidated = function() {
    $log.info('Eikon session is invalidated.');
    return $q(function(resolve) {
      winINetCookieRepository.deleteEikonSsoCookies()
          .finally(function() {
            $log.info('SSO Cookies deleted.');
            resolve();
          });
    });
  };

  function getEikonTokenFromSingleCookie(cookie) {
    var regex = /^iPlanetDirectoryPro="([^"]+)";/;
    var matches = regex.exec(cookie);
    if (!matches) {
      return;
    }
    return matches[1];
  }

  function rejectIfImpersonating() {
    return impersonationService.isImpersonating().then(function (isImpersonating) {
      if (isImpersonating) {
        return $q.reject('Impersonator cannot establish Eikon session.');
      }
    });
  }

  function rejectIfRediVersionDoesNotSupportEikon() {
    return rediVersionCheck.isExpectingVersionFromRedi().then(function(shouldGetEikonCookies){
      if (!shouldGetEikonCookies) {
        return $q.reject('R+ version does not support Eikon sessions');
      }
    });
  }

  function rediVersionHandlesWinINet() {
    return rediVersionCheck.isGreaterThanOrEqualTo('17.0.2.002');
  }

  function getCookies() {
    if (rediVersionHandlesWinINet()) {
      return handleWinINetCookies();
    }
    return getCookiesFromServer();

  }

  function handleWinINetCookies() {
    return winINetCookieRepository
        .getEikonSsoCookies()
        .then(validateEikonTokenFromCookiesOrReject)
        .catch(function() {
          return handleNoValidWinINetCookies();
        });
  }

  function validateEikonTokenFromCookiesOrReject(cookies) {
    var eikonToken = that.extractEikonToken(cookies);
    return eikonHeartbeatRepository.get(eikonToken).then(function() {
      $log.info('The retrieved WinINet cookies for Eikon are still valid');
      return cookies;
    }).catch(function() {
      $log.info('The retrieved WinINet cookies for Eikon are no longer valid, retrieving new one.');
      return $q.reject();
    });
  }

  function handleNoValidWinINetCookies() {
    $log.info('R+ Did not return any wininet cookies OR they were invalid');
    return winINetCookieRepository.getRtDeviceCookie().then(function(maybeRtDeviceCookie){
      return getCookiesFromServer(maybeRtDeviceCookie)
        .then(function(cookies) {
          winINetCookieRepository.setEikonSsoCookies(cookies);
          return cookies;
        });
    })
  }

  function getCookiesFromServer(rtDeviceCookie) {
    var accessToken = authTokenProvider.get().access_token;

    return authApiFactory.create().then(function (authApi) {
      if (!accessToken) {
        $log.error(
            'Fetching Eikon secure sign-on cookies failed due to missing access token');
        return $q.reject(new Error(
            'Fetching Eikon secure sign-on cookies failed due to missing access token'));
      } else {
        return authApi.one('eikonsso')
            .withHttpConfig({ignoreAuthModule: true})
            .get(null,
                {
                  Authorization: 'Bearer ' + accessToken,
                  rtDevice: rtDeviceCookie ? rtDeviceCookie.value : null
                })
            .catch(function(error) {
                  var errorMessage = error.data.error_description || error.data.error;

                  $log.error('Fetching Eikon secure sign-on cookies failed: ' +
                      errorMessage || error.data);
                  return $q.reject(new Error(
                      'Fetching Eikon secure sign-on cookies failed: ' +
                      errorMessage));
                });
      }
    });
  }

  function logoutFromServer(cookieValue) {
    return authApiFactory.create().then(function (authApi) {
      return authApi.one('eikonsso')
          .one('logout')
          .withHttpConfig({ignoreAuthModule: true})
          .get(null, {iPlanetDirectoryPro: cookieValue})
          .then(function() {
            $log.info('Successfully invalidated eikon session');
          })
          .catch(function() {
            $log.info('Error invalidating eikon session');
          })
    });
  }


  function publishRegisterWithEikon() {
    var eikonSessionCookieNames = {
      sessionCookies: [EIKON_SESSION_COOKIE_NAME]
    };
    $log.info('register-with-eikon');
    openFinApi.publish('register-with-eikon', eikonSessionCookieNames);
  }
}];



//////////////////
// WEBPACK FOOTER
// /app/~/redi-idp-web-lib/dist/business/eikonSsoService.js
// module id = 115
// module chunks = 0